import './App.css';
import Biopic from './components/Biopic';
import Resume from './components/Resume';
import { Tutoring } from './components/Tutoring';

export const calendlyLink = 'https://calendly.com/gandhiprep/1h-private-session';

function App() {
  const hour = new Date().getHours();
  const isDark = hour < 7 || hour > 17;

  return (
    <div className={'app' + (isDark ? ' app-dark-mode' : '')}>
      <header className="header"></header>
      <div className='profile-title'>
        <div className='full-name'>
          <span className='first-name'>Jay </span>
          <span className='last-name'>Gandhi</span>
        </div>
      </div>
    </div>
  );
}

export default App;
